import React from 'react'
import { Mail, MessageSquare, Building2, MapPin, CreditCard, Shield, FileText } from 'lucide-react'

interface VendorIconProps {
  vendor?: string
  className?: string
}

export const VendorIcon: React.FC<VendorIconProps> = ({ vendor, className = "h-6 w-6" }) => {
  if (!vendor) return null

  const vendorLower = vendor.toLowerCase()

  if (vendorLower.includes('m365') || vendorLower.includes('microsoft 365') || vendorLower.includes('outlook')) {
    return (
      <div className={`${className} relative`}>
        <Mail className={className} style={{ color: '#0078d4' }} />
        <div className="absolute -bottom-0.5 -right-0.5 w-2 h-2 bg-[#0078d4] rounded-full border border-white dark:border-slate-800" />
      </div>
    )
  }

  if (vendorLower.includes('teams') || vendorLower.includes('microsoft teams')) {
    return (
      <div className={`${className} relative`}>
        <MessageSquare className={className} style={{ color: '#6264a7' }} />
        <div className="absolute -bottom-0.5 -right-0.5 w-2 h-2 bg-[#6264a7] rounded-full border border-white dark:border-slate-800" />
      </div>
    )
  }

  if (vendorLower.includes('zillow')) {
    return <Building2 className={className} style={{ color: '#006AFF' }} />
  }

  if (vendorLower.includes('google') || vendorLower.includes('places')) {
    return <MapPin className={className} style={{ color: '#4285F4' }} />
  }

  if (vendorLower.includes('stripe')) {
    return <CreditCard className={className} style={{ color: '#635BFF' }} />
  }

  if (vendorLower.includes('persona') || vendorLower.includes('withpersona')) {
    return <Shield className={className} style={{ color: '#6366F1' }} />
  }

  if (vendorLower.includes('docusign')) {
    return <FileText className={className} style={{ color: '#003DA5' }} />
  }

  if (vendorLower.includes('sendgrid')) {
    return <Mail className={className} style={{ color: '#1A82E2' }} />
  }

  return null
}

export const getVendorIcon = (vendor?: string): React.ComponentType<{ className?: string }> => {
  if (!vendor) return Mail

  const vendorLower = vendor.toLowerCase()

  if (vendorLower.includes('m365') || vendorLower.includes('microsoft 365') || vendorLower.includes('outlook')) {
    return ({ className = "h-6 w-6" }) => (
      <div className={`${className} relative`}>
        <Mail className={className} style={{ color: '#0078d4' }} />
        <div className="absolute -bottom-0.5 -right-0.5 w-2 h-2 bg-[#0078d4] rounded-full border border-white dark:border-slate-800" />
      </div>
    )
  }

  if (vendorLower.includes('teams') || vendorLower.includes('microsoft teams')) {
    return ({ className = "h-6 w-6" }) => (
      <div className={`${className} relative`}>
        <MessageSquare className={className} style={{ color: '#6264a7' }} />
        <div className="absolute -bottom-0.5 -right-0.5 w-2 h-2 bg-[#6264a7] rounded-full border border-white dark:border-slate-800" />
      </div>
    )
  }

  if (vendorLower.includes('zillow')) {
    return ({ className = "h-6 w-6" }) => <Building2 className={className} style={{ color: '#006AFF' }} />
  }

  if (vendorLower.includes('google') || vendorLower.includes('places')) {
    return ({ className = "h-6 w-6" }) => <MapPin className={className} style={{ color: '#4285F4' }} />
  }

  if (vendorLower.includes('stripe')) {
    return ({ className = "h-6 w-6" }) => <CreditCard className={className} style={{ color: '#635BFF' }} />
  }

  if (vendorLower.includes('persona') || vendorLower.includes('withpersona')) {
    return ({ className = "h-6 w-6" }) => <Shield className={className} style={{ color: '#6366F1' }} />
  }

  if (vendorLower.includes('docusign')) {
    return ({ className = "h-6 w-6" }) => <FileText className={className} style={{ color: '#003DA5' }} />
  }

  if (vendorLower.includes('sendgrid')) {
    return ({ className = "h-6 w-6" }) => <Mail className={className} style={{ color: '#1A82E2' }} />
  }

  return Mail
}



